const TRANSLATION_DE = {
    0: 0,
    confirmDeletion: 'Löschen bestätigen',
    deleteTheTemplateFor: 'Vorlage löschen ',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    createContent: 'Inhalte erstellen',
    askAQuestion: 'Frage stellen',
    createAPoll: 'Abstimmung starten',
    createAPost: 'Post erstellen',
    orChooseFromTemplatesBelow: 'oder eine der Vorlagen (s.u.) auswählen',
    on: 'An',
    off: 'Aus',
    Off: 'Aus',
    never: 'Nie',
    chooseTemplate: 'Vorlage wählen ',
    thereAreNoTemplatesCreated: 'Keine Vorlagen erstellt',
    howAreYouToday: 'Wie geht es Dir heute? ',
    selectEmotion: 'Wähle einen Emoji',
    question: 'Frage',
    genderSelection: 'Geschlecht',
    all: 'Alle',
    male: 'Männlich',
    female: 'Weiblich',
    settings: 'Einstellungen',
    support: 'Hilfe',
    privacyPolicy: 'Datenschutzbestimmungen',
    about: 'Über',
    dayReview: 'Mein Tag',
    dailyReflection: 'Wie war mein Tag',
    youLiked: 'Gefällt dir',
    like: 'Gefällt mir',
    edit: 'Bearbeiten',
    answered: 'Beantwortet',
    showLess: 'Weniger anzeigen',
    showMore: 'Mehr anzeigen',
    search: 'Suchen',
    targetGroup: 'Zielgruppe',
    quickAction: 'Abkürzung',
    select: 'Auswahl',
    selectByGroup: 'Nach Gruppe auswählen',
    selectSchoolYearsThatYouLikeToTarget: 'Jahrgänge wählen',
    years: 'Jahrgänge',
    year: 'Jahrgang',
    selectClassesThatYouLikeToTarget: 'Gewünschte Klassen wählen',
    classes: 'Klassen',
    class: 'Klasse',
    selectACustomListThatYouLikeToTarget: 'Benutzerdefinierte Liste wählen',
    custom: 'Benutzerdefiniert ',
    selectTeachersYouWouldLikeToTarget: 'Lehrer wählen',
    staff: 'Mitarbeiter',
    selectYears: 'Jahre auswählen',
    selectClasses: 'Klassen auswählen',
    selectFromMyStudents: 'Aus meinen Schülern wählen',
    multipleClasses: 'Klassen',
    multipleYears: 'Jahrgänge',
    allStudents: 'Alle Schüler',
    done: 'Fertig',
    waitForTeachersToFeedYouWithSomeNewInformations: 'Auf Informationen der Lehrer warten',
    feedIsEmpty: 'Eingabefeld ist leer',
    thereIsNoFeedForThisSearch: 'Kein Ergebnis für diese Suche',
    createNewPostsForYourStudentsAndHereIsAShortcutForYou: 'Neuen Post erstellen',
    waitForTeacherToFeedYouWithSomeNewInformation: 'Auf Informationen der Lehrer warten',
    createFeedPost: 'Beitrag erstellen',
    targetList: 'Zielgruppe',
    beAmazing: 'Sei großartig!',
    login: 'Log In',
    getStarted: 'Los geht’s!',
    enterYourSchoolEmail: 'Gib deine Schulemailadresse ein',
    password: 'Passwort',
    email: 'E-Mail',
    requestNewPassword: 'Neues Passwort anfordern',
    newPassword: 'Neues Passwort',
    enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount: 'Gib deine Schulemailadresse ein und du erhälst eine E-Mail mit einem Bestätigungslink in deinen Account',
    sendRequest: 'Anfrage senden',
    verifyYourEmail: 'E-Mail bestätigen',
    weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere:
        'Wir haben dir einen Link geschickt, mit dem du wieder in dein Konto kommst. Prüfe deinen Posteingang und füge den Token hier ein. ',
    resendARequest: 'Anfrage erneut senden',
    didntGetAMail: 'Du hast keine E-Mail erhalten? ',
    submit: 'Abschicken',
    enterYourNewPassword: 'Neues Passwort eingeben',
    apply: 'Beantragen',
    howDoYouFeel: 'Wie fühlst du dich?',
    poll: 'Abstimmung  ',
    thereAreNoAnswersOrFeedbacksForThisDay: 'Für diesen Tag gibt es keine Antworten oder Feedback',
    title: 'Titel',
    message: 'Nachricht ',
    requested: 'Angefragt',
    anonymous: 'Anonym',
    url: 'URL ',
    addPhoto: 'Foto hinzufügen',
    removePhoto: 'Foto entfernen',
    youAreAllDone: 'Fertig!',
    congratsEverythingIsDoneForNowWaitForNewTasks: 'Gratuliere, du bist fertig! Warte auf neue Aufgaben…',
    excellentWorkWeAreDelightedToHearThingsAreSoMuchBetter: 'Gut gemacht! Schön zu hören, dass es dir besser geht.',
    thisIsYourSafePlaceAndNothingWillBeShared: 'Dies ist Dein privater Raum. Nur du kannst sehen was du schreibst.',
    enterANameForTodaysNotes: 'Benenne deinen heutigen Eintrag',
    iDontWantToSaveNotes: 'Ich möchte meine Einträge nicht speichern',
    worse: 'Schlechter',
    sorryToHearThatThingsAreWorseWhichOfTheFollowingWouldHelpRightNow:
        'Es tut uns leid zu hören, dass es dir schlechter geht. Welche von den Vorschlägen unten kann dir jetzt weiterhelfen?',
    muchWorse: 'Viel schlechter',
    sorryToHearThatThingsAreMuchWorseAndWhichOfTheFollowingWouldHelpRightNow:
        'Es tut uns leid zu hören, dass es dir viel schlechter geht. Welche von den Vorschlägen unten kann dir jetzt weiterhelfen?',
    same: 'Genauso',
    whatAreSomeIdeasToMakeThingsBetter: 'Was kannst du jetzt tun, um die Lage zu verbessern?',
    better: 'Besser',
    goodToHearThingsAreBetterAndWhatAreSomeIdeasToTakeItEvenFurther:
        'Schön zu hören, dass sich deine Lage verbessert hat. Hast du Ideen wie du sie vielleicht noch besser machen könntest? ',
    muchBetter: 'Viel besser',
    greatToHearThingsAreMuchBetterAndThinkAboutHowToImproveEvenMoreOrKeepItOnAPositiveLevel:
        'Schön zu hören, dass sich die Lage verbessert hat. Hast du Ideen wie du sie vielleicht noch besser machen könntest? ',
    ImOkWithIt: 'Das ist in Ordnung',
    IdPreferIfTheyWereBetter: 'Es wäre schön, wenn die Lage besser wäre',
    loadMoreSuggestions: 'Weitere Vorschläge',
    continue: 'Weiter',
    deleteNote: 'Eintrag löschen',
    today: 'Heute',
    comparedToLastTimeTodayIamFeeling: 'Verglichen mit dem letzten Mal fühle ich mich heute....',
    howDoYouFeelComparedToLastTimeYouDidThePoll: 'Wie fühlst du dich, verglichen mit der letzten Umfrage?',
    thisInformationWillBeSharedWith: 'Diese Info wird auch deine(n) Lehrer(in) geschickt',
    feelFreeToShareAnyThoughtsHereWhyYouFeelThisWay: 'Falls du Lust hast, kannst du hier beschreiben warum du dich so fühlst',
    feedback: 'Feedback',
    choose: 'Auswahl',
    newFeeds: 'Neue Einträge',
    openTasks: 'Offene Aufgaben',
    taskArchive: 'Aufgaben Archiv',
    congratsAndEverythingIsDoneForNowAndWaitForNewTasksFromYourTeacher: 'Gratuliere, alles ist erledigt! Warte auf neue Aufgaben von deinem Lehrer',
    newConversation: 'Neuer Chat',
    teacher: 'Lehrkraft',
    teachers: 'Lehrer',
    counselor: 'Vertrauenslehrkraft',
    Counselor: 'Vertrauenslehrkraft',
    Counsellor: 'Vertrauenslehrkraft',
    secretKey: 'Passwortschlüssel',
    advancedSettings: 'Erweiterte Einstellungen',
    showDailyReflectionScreen: 'Wie war mein Tag anzeigen',
    termsAndConditions: 'Geschäftsbedingungen',
    surname: 'Nachname',
    firstName: 'Vorname',
    gender: 'Geschlecht',
    other: 'Andere ',
    thisIsYourSafePlace: 'Hier bist du sicher  ',
    thisIsYourPrivateRoom: 'Das ist der private Teil deines Profils. Nur du kannst sehen was du schreibst.',
    safePlaceWithDailyReflectionNotes: 'Diese Notizen kannst nur du sehen',
    personalInformation: 'Persönliche Informationen',
    privacyAndSecurity: 'Datenschutz ',
    dashboard: 'Überblick',
    update: 'Aktualisieren',
    unselect: 'Auswahl aufheben',
    noResults: 'Keine Ergebnisse',
    open: 'Öffnen',
    share: 'Teilen',
    back: 'Zurück',
    task: 'Aufgabe',
    tasks: 'Aufgaben',
    logout: 'Ausloggen',
    save: 'Speichern',
    name: 'Name',
    profile: 'Profil',
    classroom: 'Klassenzimmer',
    feed: 'Feed',
    live: 'Live',
    archive: 'Archiv',
    yesterday: 'Gestern',
    tomorrow: 'Morgen',
    results: 'Ergebnisse',
    required: 'Erforderlich',
    schedule: 'Zeitplan',
    happy: 'glücklich',
    ecstatic: 'begeistert',
    inspired: 'inspiriert',
    calm: 'ruhig',
    lethargic: 'träge',
    grumpy: 'verärgert',
    sad: 'traurig',
    stressed: 'gestresst',
    angry: 'wütend',
    sunday: 'Sonntag',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    scheduled: 'Geplant',
    delivered: 'Gesendet',
    first: 'Erste ',
    second: 'Zweite',
    third: 'Dritte',
    seen: 'Gesehen',
    selectStaff: 'Mitarbeiter auswählen',
    forgotPassword: 'Passwort vergessen?',
    repeatPassword: 'Passwort wiederholen',
    retypePassword: 'Passwort erneut eingeben',
    changePassword: 'Passwort ändern',
    hidePassword: 'Passwort ausblenden',
    dailyFeedback: 'Tägliches Feedback',
    createNew: 'Erstelle neu',
    selectionType: 'Auswahl',
    enterSurname: 'Nachnamen eingeben',
    enterEmail: 'E-Mail eingeben',
    newMessage: 'Neue Nachricht!',
    myTasks: 'Meine Aufgaben',
    addOption: 'Option hinzufügen',
    newQuestion: 'Neue Frage',
    editQuestion: 'Frage bearbeiten',
    editPost: 'Beitrag bearbeiten',
    editPoll: 'Abstimmung bearbeiten',
    editGroup: 'Gruppe bearbeiten',
    tomorrowPlans: 'Pläne für morgen',
    confirmStopping: 'Bestätigen Sie das Anhalten',
    newPoll: 'Neue Abstimmung',
    answer: 'Antworten',
    post: 'Post',
    hi: 'Hallo',
    lastTime: 'Letztes Mal',
    suggestions: 'Vorschläge',
    sendAnswer: 'Antwort senden',
    comment: 'Kommentar',
    ok: 'OK',
    passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol:
        'Passwort muss länger als 8 Zeichen haben und muss Groß-, und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten',
    enterYourWorkEmailAndPassword: 'Login E-Mail eingeben',
    submitNewPassword: 'Neues Passwort bestätigen',
    pleaseCheckYourMailToConfirmYourEmailAddress: 'Wir haben eine E-Mail an dich geschickt, um die Adresse zu bestätigen. Bitte klick auf die Bestätigung in der E-Mail',
    howDoYouFeelAboutThingsBeingTheSameToday: 'Wie denkst du darüber, dass es dir heute genauso geht?',
    pollHasBeenUpdated: 'Abstimmung wurde aktualisiert',
    typeAPostTitle: 'Titel eingeben',
    addAnOptionalMessage: 'Schreib eine Nachricht',
    writeYourMessageHere: 'Hier Nachricht schreiben',
    enterUrlLink: 'Web-Link eingeben',
    saveAndContinue: 'Sichern und weiter',
    nameOfTodayNote: 'Name für die heutige Notiz',
    whatAreJust3GoodThingsThatHappenedToday: 'Welche drei Dinge waren heute gut?',
    yourDirectManager: 'Dein direkter Manager',
    secretKeyHasBeenSaved: 'Sicherheitscode gespeichert',
    enterYourSecretKeyToEncryptLllYourMessagesAndAnswers: 'Gib hier einen persönlichen Sicherheitscode ein, um deine Notizen zu verschlüsseln',
    enterSecretKey: 'Sicherheitscode eingeben',
    advancedSettingsAreSuccessfullySaved: 'Die zusätzlichen Einstellungen sind gespeichert',
    youCanUseTheButtonsAboveToContactYourTeacherOrCounselorForSupportAtAnyPoint: 'Du kannst die Felder oben benutzen, um deinen Lehrer oder Vertrauenslehrer zu kontaktieren',
    waitForStudentsToContactYouToHelpThem: 'Hier werden die Nachrichten der Schüler sein, die dich kontaktieren',
    passwordsDoNotMatch: 'Passwörter sind nicht identisch',
    startNewChat: 'Neuen Chat starten',
    shareWithTeacher: 'Mit dem Lehrer teilen',
    tasksForThisSection: 'Aufgaben in diesem Bereich',
    howWasYourDay: 'Wie war dein Tag?',
    thisIsAutoReplyMessage: 'Dies ist eine automatische Nachricht',
    thankYouForReachingOutWeWillReplyToYourMessageSoonIfYouOrSomeoneYouKnowIsInImmediateDangerPleaseCallEmergencyServices:
        'Vielen Dank für deine Nachricht. Wir werden dir sobald wie möglich antworten.',
    doYouThinkThingsAreForAnyReasonInParticular: 'Denkst du, dass es einen bestimmten Grund gibt, warum du dich {{result}} fühlst?',
    yourPrivateNotes: 'Persönliche Notizen',
    createNewPoll: 'Neue Abstimmung starten',
    saveAsTemplate: 'Als Vorlage speichern',
    addPostContentHere: 'Hier den Inhalt des Beitrags hinzufügen',
    typeAPollQuestion: 'Hier die Frage für die Abstimmung eingeben',
    questionHasBeenUpdated: 'Frage wurde aktualisiert',
    questionHasBeenPosted: 'Frage wurde verschickt',
    iDontWantToThinkAboutThisNow: 'Ich möchte jetzt nicht darüber nachdenken',
    appVersion: 'Anwendungsversion',
    selectLanguage: 'Sprache auswählen',
    userIsUpdated: 'Benutzer ist aktualisiert',
    imageIsNotUploaded: 'Bild ist nicht hochgeladen',
    feedHasBeenUpdated: 'Feed wurde aktualisiert',
    permissionIsNotAccepted: 'Erlaubnis ist nicht akzeptiert',
    feedHasBeenPosted: 'Feed wurde veröffentlicht',
    pollHasBeenPosted: 'Abstimmung wurde veröffentlicht',
    templateHasBeenSaved: 'Vorlage wurde gespeichert',
    privateNoteHasBeenSaved: 'Private Notiz wurde gespeichert',
    yourEmotionHasBeenShared: 'Ihre Emotionen wurden geteilt',
    writePersonalNotesHere: 'Schreiben Sie hier Ihre persönlichen Notizen (nur Sie können diese sehen)',
    compareToLastTime: 'Vergleiche mit dem letzten Mal',
    yourAnswerIsSaved: 'Deine Antwort ist gespeichert',
    staySecuredFirst: 'Lass uns deine Daten schützen!',
    day: 'Tag',
    dateOfBirth: 'Geburtsdatum',
    teacherInfo: 'Lehrer Details',
    studentInfo: 'Schüler Details',
    manage: 'Bearbeiten',
    openListWithAllClassesFromThisSchool: 'Liste mit allen Klassen öffnen, die zu dieser Schule gehören',
    wizardToCreateNewClassAddStudentsAndHeaTteacher: 'Hier neue Klasse, neue Schüler und einen Leiter hinzufügen',
    openListWithAllTeachersThatGoToThisSchool: 'Liste mit allen Lehrern öffnen, die zu dieser Schule gehören',
    wizardToCreateNewTeacherAndLinkItToProperClass: 'Hier neuen Lehrer hinzufügen und einer Klasse zuordnen',
    chooseDataRange: 'Wähle den Datenbereich',
    thisListRepresentsAllContentFromThisTypeYouCanEditOrDeleteTt: 'Diese Liste zeigt alle Inhalte dieser Art. Du kannst sie verändern oder löschen',
    lastCreatedpoll: 'Letzte Abstimmung',
    lastCreatedfeed: 'Letzter Feed',
    lastCreatedquestion: 'Letzte Frage',
    listOfDays: 'Liste der Tage',
    selectThisquestion: 'Diese Umfrage',
    selectThispoll: 'Diese Abstimmung wählen',
    selectThisfeed: 'Diesen Feed wählen',
    createOwn: 'Eigene Version machen',
    showAllContent: 'Alle Inhalte zeigen',
    programDuration: 'Programm Dauer',
    seeThisProgram: 'Dieses Programm verwenden',
    programs: 'Programme',
    Programs: 'Programme',
    hereYouCanCreateAPollToLearnMoreAboutYourStudents: 'Hier kannst du eine Umfrage starten und mehr über deine Schüler erfahren',
    askAnOpenQuestionToGetDetailedFeedback: 'Stelle hier eine offene Frage, um detaillierte Antworten zu bekommen',
    classManagement: 'Klassen bearbeiten',
    teacherManagement: 'Lehrer bearbeiten',
    analyze: 'Analytik',
    created: 'Erstellt',
    pickOneOption: 'Wählen Sie eine Option',
    listOfClasses: 'Liste der Klassen',
    newClass: 'Neue Klasse',
    action: 'Handlung',
    numberOfStudents: 'Anzahl der Schüler',
    listOfTeachers: 'Liste der Lehrer',
    newTeacher: 'Neue Lehrer',
    options: 'Optionen',
    refresh: 'Aktualisieren',
    selectDate: 'Datum auswählen',
    time: 'Zeit',
    date: 'Datum',
    Repaet: 'Wiederholen',
    feedDescription: 'Hier kannst du Text, Bilder, Vidoes or Links hinzufuegen',
    studentsLoginData: 'Schüler Login Daten',
    listOfStudentsWhoHaventLoggedInYet: 'Liste von Schülern und Schülerinnen, die sich noch nicht eingeloggt haben',
    'Open list': 'Öffnen',
    'Number of answers': 'Anzahl der Antworten',
    easilyManageYourStudentsAndTeachersWithSeparateFunctions: 'Verwalte deine Schüler und Lehrer einfach mit getrennten Funktionen',
    userManagement: 'Benutzerverwaltung',
    and: 'und',
    chat: 'Chat',
    trackCounseling: 'Beratung nachverfolgen',
    openLink: 'Link öffnen',
    openListOfUsersWhoHaventLoggedIn: 'Öffne die Liste der Benutzer, die sich nicht angemeldet haben',
    loadMoreClasses: 'Mehr Klassen laden',
    loginInfo: 'Login Information',
    role: 'Rolle',
    loadMore: 'Mehr laden',
    noTeachersYet: 'Noch keine Lehrer',
    classInfo: 'Klassen Information',
    enterClassName: 'Geben Sie den Klassennamen ein',
    enterSchoolYear: 'Geben Sie das Schuljahr ein',
    schoolYear: 'Schuljahr',
    className: 'Klassennamen',
    listOfStudents: 'Schülerliste',
    doYouWantToRemoveStudent: 'Möchten Sie den Schüler löschen?',
    doYouWantToDeleteClass: 'Möchten Sie die Klasse löschen?',
    emailIsInvalid: 'E-Mail ist ungültig.',
    emailIsAvailable: 'E-Mail ist verfügbar!',
    emailAlreadyExists: 'E-Mail existiert bereits!',
    fieldIsRequired: 'Feld ist erforderlich',
    showPassword: 'Passwort anzeigen',
    enterName: 'Name eingeben',
    selectRole: 'Rolle auswählen',
    teachersRoleNotSetYet: 'Lehrrolle noch nicht ausgewählt',
    create: 'Schaffen',
    doYouWantToDeleteTeacher: 'Möchten Sie den Lehrer löschen?',
    classIsCreated: 'Die Klasse ist gemacht!',
    reminderForToday: 'Erinnerung für heute',
    closed: 'abgeschlossen',
    youDontHaveAnyRemindersForToday: 'Du hast keine Erinnerungen für heute',
    firstEnterANote: 'Gib zuerst eine Notiz ein',
    noteIsCreated: 'Notiz wird erstellt',
    reminderHasBeenChanged: 'Erinnerung wurde geändert!',
    status: 'Status',
    exportReport: 'Bericht exportieren',
    notes: 'Notizen',
    Notes: 'Notizen',
    editReminder: 'Erinnerung bearbeiten',
    removeReminder: 'Erinnerung löschen',
    enterYourNoteHere: 'Notiz hinzufügen',
    createANote: 'Notiz erstellen',
    addReminder: 'Erinnerung hinzuffügen',
    teacherLogin: 'Lehrer-Login',
    enterCredentialsYouReceivedFromSchool: 'Gib deine Schul- Anmeldedaten ein',
    deletePost: 'Beitrag löschen',
    doYouWantToDeletePost: 'Möchten Sie diesen Eintrag löschen?',
    setDateForReminderOfStudent: 'Setze ein Datum, an dem du an diese(n) Schüler(in) erinnert werden möchtest',
    createReminder: 'Erinnerung erstellen',
    writeFullAnswerHere: 'Schreibe hier deine Antwort',
    stop: 'Beenden',
    answers: 'Antworten',
    actionTaken: 'Fall in Bearbeitung',
    seenBy: 'Gesehen von',
    thereAreNoAnswersForThatDay: 'Es gibt keine Antworten für diesen Tag ...',
    describeHowYouWillDealWithThisStudent: 'Beschreiben Sie, wie Sie mit diesem Schüler umgehen werden',
    writeYourThoughtsHere: 'Hier kannst du deine Gedanken dazu aufschreiben',
    studentData: 'Schülerdaten',
    student: 'Schüler',
    enterStudentUPN: 'UPN eingeben',
    showAll: 'Alles zeigen',
    loginStatistic: 'Login-Statistiken',
    hereYouCanAddTextImagesVideosOrLinks: 'Hier können Sie Texte, Bilder, Videos oder Links hinzufügen',
    typeAQuestionTitle: 'Geben Sie einen Fragetitel ein',
    typeYourHeadlineHere: 'Geben Sie hier Ihre Überschrift ein',
    optional: ' (Optional)',
    invalidLink: 'Ungültiger Link',
    chooseTemplateFor: 'Vorlage auswählen für ',
    doYouWantToDeleteThis: 'Willst du das löschen?',
    yourDataIsUpdated: 'Deine Daten werden aktualisiert!',
    yourDataIsNotUpdated: 'Deine Daten werden nicht aktualisiert!',
    contentIsCreated: 'Inhalt wird erstellt!',
    contentIsNotCreated: 'Inhalt wird nicht erstellt!',
    templateIsCreated: 'Vorlage ist erstellt!',
    templateIsNotCreated: 'Vorlage wird nicht erstellt!',
    allCreatedContent: 'Alle erstellten Inhalte',
    runProgram: 'Programm starten',
    teachersOnly: 'Nur für Lehrer',
    programTitle: 'Programmtitel',
    thisToolHelpsYouPlanTheEntireProgramOnce: 'Dieses Werkzeug hilft dir, das gesamte Programm einmal zu planen, damit du es nicht ständig überprüfen musst',
    startDate: 'Anfangsdatum',
    selectDays: 'Tage wählen',
    pickTime: 'Zeit wählen',
    thisProgaramIsAlreadyRunning: 'Dieses Programm wird bereits ausgeführt, erneut ausführen?',
    youAreRunningThisProgramSuccessfully: 'Sie führen dieses Programm erfolgreich aus',
    surveys: 'Umfragen',
    Surveys: 'Umfragen',
    survey: 'Umfrage',
    description: 'Beschreibung',
    typeASurveyTitle: 'Umfragetitel erstellen',
    addASurveyDescription: 'Umfragenbeschreibung hinzufügen',
    surveyTitle: 'Umfragetitel',
    section: 'Abschnitt',
    sections: 'Abschnitte',
    enterSectionTitleHere: 'Abschnittstitel hinzufügen',
    enterSectionDescriptionHere: 'Abschnittsbeschreibung hinzufügen',
    enterQuestionHere: 'Frage hinzufügen',
    openAnswer: 'Antwort öffnen',
    addQuestion: 'Frage hinzufügen',
    addSection: 'Kategorie hinzufügen',
    deleteSurvey: 'Umfrage löschen',
    doYouWantToRemoveSurvey: 'Möchten Sie die Umfrage löschen?',
    yesNo: 'Ja/Nein',
    confirmation: 'Bestätigung',
    manageRunningPrograms: 'Laufenden Programme managen',
    numberOfSections: 'Anzahl der Abschnitte',
    thisToolHelpsYouToControlAllRunningProgramsAndTrackTheirInfluenceToStudents:
        'Dieses Tool hilft dir alle laufenden Programme zu managen und ihren Effekt auf die Schüler zu verfolgen',
    currentPrograms: 'Aktuelle Programme',
    yourRunningProgramListIsEmptyStartByAddingOneFromTheListOfPrograms:
        'Deine Liste laufender Programme ist leer. Starte ein Neues, indem du eines von der Programmliste auswählst',
    deleteProgram: 'Programm löschen',
    days: 'Tage',
    surveyIsCreated: 'Umfrage wird erstellt',
    yes: 'Ja',
    no: 'Nein',
    Yes: 'Ja',
    No: 'Nein',
    configureSurvey: 'Umfrage konfigurieren',
    editSurvey: 'Umfrage bearbeiten',
    runSurvey: 'Umfrage starten',
    selectMyStudents: 'Wählen Sie meine Schüler.',
    openFavorites: 'Favoriten öffnen',
    thereIsNoDataToShow: 'Keine Daten zum Anzeigen ',
    selectAll: 'Wählen Sie Alle',
    deselectAll: 'Alle abwählen',
    saveAsFavorite: 'Als Favorit speichern',
    doYouWantToDeleteFavorite: 'Möchten Sie die Favoritengruppe löschen?',
    saveYourFavoriteGroup: 'Speichern Sie Ihre Lieblingsgruppe',
    deleteWasSuccessful: 'Löschen war erfolgreich',
    listOf: 'Liste: ',
    deleteThis: 'Lösch das:',
    editThis: 'Bearbeite dies',
    youHaveNoChats: 'Du hast noch keine Chats',
    reminderSetFor: 'Erinnerung eingestellt für ',
    doYouWantToDeleteThisTask: 'Möchten Sie diese Aufgabe löschen?',
    assignedTo: 'Für:',
    selectTeacher: 'Lehrer auswählen',
    wellbeingTracker: 'Wohlgefühl Tracker',
    open_poll: 'Nicht-anonyme Abstimmung',
    open_question: 'Nicht-anonyme Frage ',
    open_survey: 'Nicht-anonyme Umfrage',
    students: 'Schüler',
    assignedActions: 'Zugewiesene Aktionen',
    reminder: 'Erinnerung',
    youDontHaveAnyAssignedAction: 'Sie haben keine zugewiesene Aktion',
    'Take Survey': 'Umfrage starten',
    'How are you?': 'Wie geht es Dir?',
    'Type an action': 'Geben Sie eine Aktion ein',
    'Do you want to close this counseling profile?': 'Möchten Sie dieses Beratungsprofil schließen?',
    'Do you want to open this counseling profile?': 'Möchten Sie dieses Beratungsprofil öffnen?',
    'This counseling profile is open!': 'Dieses Beratungsprofil ist offen!',
    'This counseling profile is closed!': 'Dieses Beratungsprofil ist geschlossen!',
    'Reminder has been removed!': 'Die Erinnerung wurde entfernt!',
    'Assign action': 'Aktion zuweisen',
    'Export data': 'Daten exportieren',
    'Message only visible to staff with special access': 'Nachricht nur für Mitarbeiter mit speziellem Zugang sichtbar',
    'Set a date when you would like to be reminded about this student': 'Legen Sie ein Datum fest, an dem Sie an diesen Schüler erinnert werden möchten',
    'Message is visible to all': 'Nachricht ist für alle sichtbar',
    'Choose a date': 'Wählen Sie ein Datum',
    'Teacher is created and password has been sent!': 'Lehrer ist erstellt und Passwort wurde gesendet!',
    'Teacher is not created!': 'Lehrkraft ist nicht erstellt!',
    'Teacher is removed!': 'Lehrer wurde entfernt!',
    'Teacher is not removed!': 'Lehrer wurde nicht entfernt!',
    'Unregistered teachers': 'Nicht registrierte Lehrer',
    'Unregistered users': 'Nicht registrierte Benutzer',
    'Registered teachers': 'Registrierte Lehrer',
    'Registered users': 'Registrierte Benutzer',
    'Login data': 'Anmeldedaten',
    'Language is changed': 'Sprache wurde geändert',
    'Current Emotion': 'Aktuelle Emotion',
    'Add a teacher': 'Lehrkraft hinzufügen',
    'Add a new class': 'Neue Klasse hinzufügen',
    'Last login': 'Letzter Log in',
    'Most Popular Emotion': 'Am häufigsten gewählte Emotionen',
    'Type any additional text here': 'Zusätzlichen Text hier eingeben',
    chooseTheAnswer: 'Wähle eine Antwort',
    findTheRightSolution: 'Finde die richtige Lösung',
    '7 Days': '7 Tage',
    '3 Months': '3 Monate',
    '1 Month': '1 Monat',
    '1 Year': '1 Jahr',
    'Add note': 'Notiz hinzufügen',
    'User activity': 'Benutzeraktivität',
    'Stop editing': 'Hör auf zu bearbeiten',
    'Student is created!': 'Schüler:in ist erstellt!',
    'Student is not created!': 'Schüler:in ist nicht erstellt!',
    'All emotions': 'Alle Emotionen',
    'Trend of your classrooms': 'Klassenzimmer Trends',
    'Your Upstrive (Tasks)': 'Deine Upstrive (Aufgaben)',
    'Write the answer': 'Schreibe die Antwort',
    assignAction: 'Aktion zuweisen',
    AssignActionToATeacherToCheckOnThisStudent: 'Lehrkraft mit der Kontrolle dieses Schülers / dieser Schülerin beauftragen',
    assignToTeacher: 'Lehrkraft zuweisen',
    journals: 'Tagebücher',
    Journals: 'Tagebücher',
    createAQuestion: 'Frage erstellen',
    turnOff: 'Ausschalten',
    staffLogin: 'Mitarbeiter/-innen Login',
    token: 'Wertmarke',
    createYourOwn: 'Inhalte selbst erstellen',
    readyToGo: 'Ready-to-go',
    favorites: 'Favoriten',
    addToFavorites: 'Zu Favoriten hinzufügen',
    repeat: 'Wiederholen',
    addToWellbeingTracker: 'Zum Wellbeing Tracker hinzufügen',
    addToAnalytics: 'Zu Analysen hinzufügen',
    open_journal: 'Vertrauliches Tagebuch',
    actionComment: 'Kommentar zur Aktion',
    lastNote: 'Letzte Anmerkung',
    Overdue: 'Überfällig',
    currentEmotion: 'Aktuelle Emotion',
    mostPopularEmotion: 'Am häufigsten gewählte Emotionen',
    messageIsVisibleToAll: 'Nachricht ist für alle sichtbar',
    messageOnlyVisibleToStaffWithSpecialAccess: 'Nachricht nur für Mitarbeiter mit speziellem Zugang sichtbar',
    assignActionSuccess: 'Aktion erfolgreich zugewiesen',
    filterIsNotSet: 'Filter wurde nicht angewendet',
    commentHasBeenSeen: 'Kommentar wurde gesehen!',
    catchUp: 'Catch-up',
    catchUpOnAnyStudentCommentsAttachedTo: 'Nacharbeiten von Kommentaren der Schüler:innen zu unangenehmen Gefühlen, die möglicherweise übersehen wurden',
    unseen: 'Ungelesen',
    markAsSeen: 'Als gesehen markieren',
    fullTraining: 'Komplettes Training',
    individualFeaturesTraining: 'Individuelles Fertigkeiten Training',
    instructionVideosForStaff: 'Anleitungsvideo für Mitarbeiter/-innen',
    deleteYourPrivateNote: 'Willst du diese private Notiz wirklich löschen?',
    emotions: 'Emotionen',
    Emotions: 'Emotionen',
    studentRemoved: 'Schüler/-in wurde entfernt',
    fileHasBeenUploadedDataWillBeUpdatedWithin24Hours: 'Datei wurde hochgeladen. Die Daten werden in den nächsten 24 Stunden erneuert.',
    Neutral: 'Neutral',
    downloadTemplateFile: 'Vorlage-Datei herunterladen',
    previousUploads: 'Vorherige Uploads',
    fileLink: 'Dateien link',
    attachFile: 'Datei anhängen',
    uploadData: 'Datei hochladen',
    noUnsignedTeachers: 'Keine unsignierten Lehrer/-innen',
    noUnsignedStudents: 'Keine unsignierten Schüler:innen',
    reviewYourLoginStatistics: 'Überprüfe deine Anmeldestatistiken',
    registeredStudents: 'Registrierte Schüler:innen',
    unregisteredStudents: 'Unregistrierte Schüler:innen',
    uploadUserData: 'Benutzerdaten hochladen',
    addATeacher: 'Lehrkraft hinzufügen',
    addANewClass: 'Neue Klasse hinzufügen',
    enterStudentsDetails: 'Schüler:innen Details hinzufügen',
    enterTeachersDetails: 'Lehrer/-innen Details hinzufügen',
    cantCreateStudentWithoutCreateClass: 'Schüler/-in kann nicht ohne Klasse hinzugefügt werden',
    createWellbeingProfile: 'Wellbeing Profil erstellen',
    yourStudentListIsEmpty: 'Deine Schüler:innen Liste ist leer',
    addAStudent: 'Schüler/-in hinzufügen',
    letThemSetTheirOwnPasswordsAfterLogin: 'Eigenes Passwort nach erstem Login erstellen lassen',
    keepThisPassword: 'Dieses Passwort behalten',
    rolemodelIsnotLoaded: 'Beispiel konnte nicht geladen werden...Lade die Seite erneut!',
    loginData: 'Anmeldedaten',
    exportData: 'Daten exportieren',
    passwordIsNotCorrect: 'Passwort stimmt nicht',
    closePopUp: 'Pop-up schließen',
    deleteStudent: 'Schüler/-in löschen',
    deleteTeacher: 'Lehrkraft löschen',
    hidePasswordmanager: 'Passwort-Manager ausblenden',
    setStudentsPasswordManually: 'Schüler:innen Passwort manuell auswählen',
    generateNewPassword: 'Neues Passwort erstellen',
    lastName: 'Nachname',
    noStudentsYet: 'Keine Schüler:innen bisher',
    loggedIn: 'Eingeloggt',
    noAnswer: 'Keine Antworten',
    changeStatus: 'Status ändern',
    answerOnHowAreYou: 'Antwort zu "Wie geht es dir?"',
    teacherRole: 'Lehrer/-innenrolle',
    selectTeacherRole: 'Lehrer/-innen Rolle auswählen',
    thisTeacherWillbe: 'Dieser Lehrer wird',
    negative: 'Negativ',
    classIsUpdated: 'Klasse ist aktualisiert',
    classIsNotUpdated: 'Klasse ist nicht aktualisiert',
    teacherIsCreatedAndPasswordHasBeenSent: 'Lehrer ist erstellt und Passwort wurde gesendet!',
    teacherIsNotCreated: 'Lehrkraft ist nicht erstellt!',
    createYourOwnContent: 'Erstelle deinen eigenen Inhalt',
    contentDeleted: 'Inhalt gelöscht',
    upcomingContent: 'Zukünftige Events',
    overview: 'Übersicht',
    feedPosts: 'Feed Post',
    welcomeBack: 'Willkommen zurück!',
    ofStudentsUsingHowAreYouTodayAtLeastOncePerWeek: '% der Schüler:innen benutzen "Wie geht es dir heute?" mindestens einmal pro Woche',
    yourClassroom: 'Dein Klassenzimmer',
    checkWhatsGoingOn: 'Prüfe was gerade vor sich geht',
    myClassroom: 'Mein Klassenzimmer',
    youDeletedTargetGroup: 'Zielgruppe löschen',
    deeperInsights: 'Tiefere Einblicke',
    findYourStudentsWhoAreLoggingUncomfortableEmotions: 'Finde Schüler:innen die negative Emotionen angeben ',
    monitoringGroups: 'Gruppe kontrollieren',
    createGroup: 'Gruppe erstellen',
    whatIsIt: 'Was ist das?',
    createdNewMonitoringGroup: 'Neue Kontrollgruppe erstellen!',
    updatedMonitoringGroup: 'Kontrollgruppe aktualisieren',
    nameANewGroup: 'Neue Gruppe benennen',
    chooseEmotions: 'Emotion wählen',
    close: 'Schließen',
    actionRequired: 'Maßnahmen erforderlich',
    stayUpToDateWithStudentSupport: 'Mit der Unterstützung von Schüler:innen auf dem Laufenden bleiben',
    actionsAssignedToMe: 'Mir zugewiesene Aufgaben',
    studentChat: 'Schüler/-innen Chat',
    unreadMessage: 'ungelesene Nachricht',
    assignedBy: 'Zugewiesen durch',
    addNote: 'Notiz hinzufügen',
    engagementStatistics: 'Engagement-Statistik',
    trackEngagementResponsivenessLogins: 'Engagement, Antwortverhalten und Anmeldungen verfolgen',
    analytics: 'Analysen',
    ofStudentsUsingUpstriveWeekly: '% aller Schüler:innen nutzen Upstrive wöchentlich',
    ofResponsesToActivePollsQuestion: '% der Antworten auf aktive Umfragen',
    ofTeachersLoggedIn: '% der Lehrkräfte haben sich angemeldet',
    ofStudentsLoggedIn: '% der Schüler:innen haben sich eingeloggt',
    displayAll: 'Alle anzeigen',
    'display all': 'Alle anzeigen',
    onlyMine: 'Nur meine',
    searchResults: 'Antworten durchsuchen',
    filter: 'Filter',
    from: 'Von',
    to: 'Bis',
    notSelected: 'Nicht ausgewählt',
    questions: 'Fragen',
    polls: 'Abstimmungen',
    Polls: 'Abstimmungen',
    runReadyToGo: 'Ready-to-go Inhalte verwenden',
    journal: 'Tagebuch',
    target: 'Zielgruppe',
    clickToBrowseResults: 'Klicke, um Ergebnisse anzuzeigen',
    by: 'Von',
    archived: 'Archiviert',
    download: 'Download',
    thereIsntAnyAnswerYet: 'Es gibt bisher keine Antworten',
    start: 'Start',
    createPosts: 'Beitrag erstellen',
    deleteFeedContent: 'Beiträge löschen?',
    congratulations: 'Herzlichen Glückwunsch',
    youHaveCompletedAllYourTasks: 'Du hast alle Aufgaben erledigt',
    submitAnswer: 'Antwort abgeben',
    takeIt: 'Annehmen',
    runReadyToGoContent: 'Ready-to-go Inhalte verwenden',
    yourFeedBackHasBeenSubmited: 'Deine Rückmeldung wurde gespeichert',
    useTemplate: 'Vorlage verwenden',
    templateDeleted: 'Vorlage wurde gelöscht',
    fileIsToBig: 'Datei ist zu groß!',
    templateIsUpdated: 'Die Vorlage wurde aktualisiert.',
    contentNeedsToBeReviewedByTheScoolAdmin: 'Der Inhalt muss von der Schulleitung überprüft werden!',
    headline: 'Überschrift',
    typeHeadlineHere: 'Gebe die Überschrift hier ein',
    supportiveText: 'Unterstützender Text',
    enterLinkOptional: 'Link hinzufügen (optional)',
    writeOption1Here: 'Schreibe hier Option 1 hinein',
    deleteOption: 'Option löschen',
    'Select target': 'Auswählen',
    pleaseFillRequiredFields: 'Pflichtfelder ausfüllen',
    updateTemplate: 'Vorlage hochladen',
    templateIsSaved: 'Vorlage wurde gespeichert!',
    publish: 'Veröffentlichen',
    surveyIsCreatedAsTemplate: 'Umfrage wurde als Vorlage gespeichert!',
    surveyIsDeleted: 'Umfrage wurde gelöscht!',
    moveSectionUp: 'Sektion nach oben verschieben',
    moveSectionDown: 'Sektion nach unten verschieben',
    headlineForSection: 'Überschrift für die Sektion',
    descriptionForSection: 'Beschreibung für die Sektion',
    moveQuestionUp: 'Frage nach oben verschieben',
    moveQuestionDown: 'Frage nach unten verschieben',
    selectTypeOfQuestion: 'Fragentyp wählen',
    writeOption: 'Schreibe hier Option {{result}} hinein',
    setupADateAndTime: 'Zeit und Datum festlegen',
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    everyMonthOn: 'Jeden Monat am',
    endDate: 'Enddatum',
    selectACategory: 'Wähle eine Kategorie',
    selectSpecificYearGroupsToGatherMoreInformationFrom: 'Wähle eine Jahrgangsstufe aus, um weitere Informationen zu erhalten',
    customize: 'Anpassen',
    selectYourFavoriteGroup: 'Wähle deine Lieblingsgruppe',
    selectCustom: 'Benutzerdefiniert ',
    setATime: 'Setze eine Zeit fest',
    readyToGoContent: 'Sofort einsatzbereite Inhalte',
    sortBy: 'Sortieren nach',
    type: 'Typ',
    evidenceBasedContentPreparedForYouByOurTeamOfExperts: 'Evidenzbasierte Inhalte von Expertenteams für dich zusammengestellt',
    'Choose from our range of ready-to-go programs designed to support your students and save you time':
        'Wähle aus unserem Angebot an sofort einsatzbereiten Programmen, die deine Schüler:innen unterstützen und dir Zeit sparen.',
    'Each of our ready-to-go surveys is designed to help you understand your students better':
        'Jede unserer sofort einsatzbereiten Umfragen soll dir helfen, deine Schüler:innen besser zu verstehen.',
    'Pick a journal that will keep your students engaged': 'Wähle einen Beitrag, der deine Schüler:innen interessiert.',
    currentlyRunning: 'In Bearbeitung',
    running: 'Läuft',
    paused: 'Pausiert',
    playProgram: 'Programm abspielen',
    pauseProgram: 'Programm pausieren',
    doYouWantToDeleteThisProgram: 'Möchtest du dieses Programm löschen?',
    doYouWantToStartThisProgram: 'Möchtest du dieses Programm starten?',
    doYouWantToStopThisProgram: 'Möchtest du dieses Programm stoppen?',
    postIndividually: 'Individuell posten',
    lastCreated: 'Zuletzt kreieren',
    youMustSelectTargetGroup: 'Du musst eine Zielgruppe auswählen!',
    youMustSelectDaysOfWeek: 'Du musst Wochentage auswählen!',
    Sun: 'So',
    Mon: 'Mo',
    Tue: 'Di',
    Wed: 'Mi',
    Thu: 'Do',
    Fri: 'Fr',
    Sat: 'Sa',
    runIt: 'Durchlaufen lassen',
    classroomTrends: 'Klassenzimmer Trends',
    searchForStudent: 'Nach Schüler/-in suchen',
    searchForTeacher: 'Nach Lehrkraft suchen',
    'all emotions': 'Alle Emotionen',
    uncomfortable: 'Unwohl',
    filterClassroom: 'Klassenzimmer filtern',
    yourIndividualStudentsResponses: 'Individuelle Antworten deiner Schüler:innen',
    uncomfortableEmontionsWithComments: 'Negative Emotionen mit Kommentaren',
    wellbeingOfTeachers: 'Wellbeing der Lehrer/-innen',
    youMustFillData: 'Du musst Daten angeben',
    actionHasBeenAssignedToTeacher: 'Aufgabe wurde der Lehrkraft zugewiesen',
    assignActionFailed: 'Aktion zuweisen fehlgeschlagen',
    sendMessage: 'Nachricht schicken',
    classroomTeacher: 'Klassenlehrer/-in',
    headOfYear: 'Jahrgangsleiter/-in',
    otherTeachers: 'Andere Lehrkräfte',
    typeAnAction: 'Geben Sie eine Aktion ein',
    sendPrivateMessageToStudent: 'Private Nachricht an einen Schüler/ eine Schülerin senden',
    messageHasBeenSent: 'Nachricht wurde gesendet',
    getDeeperInsights: 'Hier kannst du Trends verfolgen',
    searchQuestion: 'Frage suchen',
    clickToSeeQuestionInDetails: 'Klicke, um die detaillierte Frage zu sehen',
    getDeeperInsightsIntoYourStudentsEmotionalTrends: 'Erhalte tiefere Einblicke in die emotionalen Trends deiner Schüler:innen',
    getInsights: 'Einblicke erhalten',
    totalCommentsLeftUsingHowAreYouToday: 'Gesamtzahl der Kommentare, die unter "Wie geht es dir heute?" hinterlassen wurden',
    basics: 'Basics',
    getBackToMainAnalytics: 'Zurück zu Hauptanalyse',
    searchStudents: 'Schüler/-in suchen',
    lastLogin: 'Letzter Log in',
    neverLoggedIn: 'Noch nie eingeloggt',
    loggedInRecently: 'Kürzlich eingeloggt',
    studentsNotFound: 'Schüler/-in nicht gefunden',
    showMoreStudents: 'Mehr Schüler:innen anzeigen',
    searchTeachers: 'Lehrer/-in suchen',
    position: 'Position',
    teachersNotfound: 'Lehrer/-in nicht gefunden',
    showMoreTeachers: 'Mehr Lehrer/-innen anzeigen',
    studentsWhoDidntRespondToAnyQuestionInPastTwoWeeks: 'Schüler:innen, die keine Fragen in den letzten zwei Wochen beantwortet haben',
    thisCanTakeAwhile: 'Dies kann eine Weile dauern',
    barView: 'Balkenansicht',
    averageResponseDistributionForSelectedPeriod: 'Durchschnittliche Antwortverteilung für den ausgewählten Zeitraum',
    percentageOfResponseDistributionByGender: 'Prozentuale Verteilung der Antworten nach Geschlecht',
    general: 'Allgemein',
    percentageOfResponseDistributionIntotalForSelectedPeriod: 'Prozentsatz der Antwortverteilung insgesamt für den ausgewählten Zeitraum',
    totalCommentsInHowareYouToday: 'Alle Kommentare zu "Wie geht es dir heute?"',
    emotion: 'Emotion',
    noOfCommentsAnsweringHowAreYouToday: 'Anzahl an Kommentaren, die auf "Wie geht es dir heute?" geantwortet haben',
    change: 'Ändern',
    thereIsnotAnyConversationYet: 'Es gibt bisher keine Unterhaltungen',
    replyOn: 'Antworten auf',
    myMessage: 'Meine Nachricht',
    'Multiple years': 'Jahrgänge',
    'Multiple classes': 'Klassen',
    addPhotoVideo: 'Foto/Video hinzufügen',
    remove: 'Löschen',
    sorryToHearThatThingsAreWorse: 'Es tut uns leid zu hören, dass es dir schlechter geht.',
    sorryToHearThatThingsAreMuchWorse: 'Es tut uns leid zu hören, dass es dir schlechter geht.',
    goodToHearThingsAreBetter: 'Schön zu hören, dass sich die Lage verbessert hat.',
    greatToHearThingsAreMuchBetter: 'Schön zu hören, dass sich die Lage verbessert hat.',
    'You have no live content': 'Es gibt noch keine Inhalte',
    'Create something and see the results live!': 'Erstelle deinen Inhalt und bekomme live feedback!',
    'Creation shortcuts for you': 'Hier kannst du Inhalte machen',
    'You have no chats': 'Du hast noch keine Chats',
    'Type a question': 'Hier Frage eingeben',
    anonymous_question: 'Anonyme Frage',
    anonymous_survey: 'Anonyme Umfrage',
    anonymous_poll: 'Anonyme Abstimmung',
    'Pick one option': 'Eine Option wählen',
    'Allow more than one answer': 'Mehr als eine Antwort erlauben',
    solutions: 'Lösungswege',
    sos: 'SOS',
    'copy message': 'Nachricht kopieren',
    "List of students who haven't logged in yet and it’s ": 'List von Schülern die sich noch nicht eingeloggt haben',
    'Students login data': 'Schüler Login Daten',
    'Select from favorites': 'Aus Favoriten auswählen',
    Favorite: 'Favorit',
    'Select your favorite group': 'Wähle deine Lieblingsgruppe',
    'New Version is Available': 'Neue Version verfügbar',
    'Delete this note?': 'Diesen Eintrag löschen?',
    'Stop tracking live results for title': 'Für {{title}} keine Ergebnisse mehr specihern',
    'Delete this favorite group?': 'Diesen Favoriten löschen?',
    'Do not agree': 'Ich stimme nicht zu',
    "If you don't agree to Terms and Conditions or Privacy Policy you are not going to be allowed to use the app!": 'Bitte Datenschutzbestimmungen und Privacy Policy zustimmen',
    'You will be logged out': 'Du wirst jetzt ausgeloggt',
    'Delete this feed?': 'Diese Beiträge löschen?',
    'Delete the template for title': 'Vorlage für {{title}}  löschen',
    'No one yet': 'Niemand bisher',
    'Seen by:': 'Gesehen von:',
    Copied: 'Kopiert',
    'Action taken': 'Fall in Bearbeitung',
    'Write your thoughts here': 'Hier kannst du deine Gedanken dazu aufschreiben',
    'Describe how will you take action about this student': 'Was genau hast du geplant?',
    'I will take action': 'Ich werde mich kümmern',
    'Ask your manager to assign you to class.': 'Bitte an Admin wenden, um eine Klasse zugeordnet zu bekommen',
    'You have no data about your classroom': 'Es gibt noch keine Daten aus deiner Klasse',
    'Terms and Conditions and Privacy Policy': 'Bedingungen, Richtlinien und Privatsphäre',
    "I confirm that I read and agree to Upstrive's":
        'Ich bestätige, dass ich die Datenschutzbestimmungen und die Bedingungen und Richtlinien von Upstrive gelesen habe und bestätige diese.',
    'Terms and Conditions': 'Bedingungen und Richtlinien',
    'I do not agree': 'Ich stimmt nicht zu',
    'New survey!': 'Neue Umfrage!',
    youHaveASurveyAbout: 'Du hast eine Umfrage zu ',
    voluntary: 'freiwillig',
    mandatory: 'Pflicht',
    'Your counseling list is empty, start with adding a new counseling profile for one of your students':
        'Die Liste ist leer. Beginne eine neue, indem du ein Profil für einen deiner Schüler erstellst.',
    'Reminder for today': 'Erinnerung für heute',
    'Track Counseling': 'Beratung nachverfolgen',
    'Congrats, everything is done for now!': 'Glückwunsch, du hast alles geschafft!',
    'Wait for new tasks...': 'Neue Aufgaben kommen sicher bald… ',
    'Manage running programs': 'Laufenden Programme managen',
    'This tool helps you to control all running programs and track their influence to students':
        'Dieses Tool hilft dir alle laufenden Programme zu managen und ihren Effekt auf die Schüler zu verfolgen',
    'Your running program list is empty, start by adding one from the list of programs':
        'Deine Liste laufender Programme ist leer. Starte ein Neues, indem du eines von der Programmliste auswählst',
    'Run program': 'Programm starten',
    "This tool helps you to schedule whole program once so you don't need to check it all the time":
        'Dieses Tool hilft dir ein Programm so zu erstellen, dass es selbstständig läuft',
    'Target group:': 'Zielgruppe',
    'Start date:': 'Anfangsdatum:',
    'Select days:': 'Tage wählen:',
    'Pick time:': 'Zeit wählen:',
    'Current programs:': 'Aktuelle Programme:',
    Running: 'Läuft',
    'Show more programs': 'Weitere Programme zeigen',
    'Choose from our range of ready-to-go programs designed to support your students and save you times now':
        'Aus einer Auswahl fertiger Programme wählen, um deine Schüler zu unterstützen und um Zeit zu sparen',
    'Create a survey': 'Umfragen erstellen',
    'Type a survey title': 'Umfragenüberschrift erstellen',
    'add a survey description': 'Umfragenbeschreibung hinzufügen',
    'enter a section title here': 'Abschnittstitel hinzufügen',
    Section: 'Abschnitt',
    Sections: 'Abschnitte',
    'enter a section description here': 'Abschnittsbeschreibung hinzufügen',
    'Enter a question here': 'Frage hinzufügen',
    'Add section': 'Kategorie hinzufügen',
    'Delete survey': 'Umfrage löschen',
    'Save Survey': 'Umfrage speichern',
    'Edit Survey': 'Umfrage bearbeiten',
    'This tool helps you to run a survey for your students': 'Dieses Tool hilft dir eine Umfrage für deine Schüler zu erstellen',
    'Configure survey': 'Umfrage konfigurieren',
    'Easily manage your students and teachers, using separate functions': 'Hier kannst du Schülern und Lehrern einfach verwalten',
    'Login info': 'Login Information',
    'Class info': 'Klassen Information',
    Download: 'Download',
    'Export report': 'Bericht exportieren',
    'Enter your note here': 'Notiz hinzufügen',
    'Add reminder': 'Erinnerung hinzuffügen',
    'Show more surveys': 'mehr Umfragen zeigen',
    'Open survey results': 'Umfragenergebnisse öffnen',
    'Take it now': 'Jetzt Umfrage starten',
    'Take it later': 'Später',
    Category: 'Kategorie',
    'Select all': 'Wählen Sie Alle',
    'Survey results': 'Umfrageergebnisse',
    'We hope you’ve had a good day!': 'Wir hoffen, Du hattest einen guten Tag!',
    'Save your favorite group': 'Speichern Sie Ihre Lieblingsgruppe',
    anonymous_journal: 'Anonymes Tagebuch',
    'Welcome back': 'Willkommen zurück!',
    'Here’s what happened while you were away': 'Hier siehst du was passiert ist während du weg warst',
    Overview: 'Übersicht',
    Posts: 'Posts',
    'Action Required': 'Maßnahmen erforderlich',
    'Your Classrooms': 'Dein Klassenzimmer',
    Browse: 'Suchen/Stöbern',
    'Engagement Statistics': 'Engagement-Statistik',
    '% of students using Upstrive (per week, any function)': '% aller Schüler/-innen nutzen Upstrive wöchentlich',
    '% of responses on active polls & questions': '% der Antworten auf aktive Umfragen',
    '% of teachers using Upstrive (per week, any function)': '% der Lehrkräfte haben sich angemeldet',
    '% of students using “How are you?” at least once per week': '% der Schüler/-innen haben sich eingeloggt',
    '% this week': '% diese Woche',
    'Click on emotion to go into the classroom details': 'Klicken Sie auf "Emotion", um zu den Details des Klassenzimmers zu gelangen',
    Default: 'Default',
    'Monitoring group': 'Gruppe kontrollieren',
    'Create Group': 'Gruppe erstellen',
    'Edit Group': 'Gruppe bearbeiten',
    'Type name in the field below': 'Geben Sie den Namen in das Feld darunter ein',
    'You have to select at least one emotion': 'Du musst mindestens eine Emotion auswählen',
    'Create Group and Apply filter': 'Gruppe erstellen',
    'Edit Group and Apply filter': 'Kontrollgruppe aktualisieren',
    'Name a new group type here': 'Nenne hier eine neue Gruppenart',
    'Created new monitoring group!': 'Neue Kontrollgruppe erstellen!',
    'Updated monitoring group!': 'Kontrollgruppe aktualisieren',
    'Search results': 'Antworten durchsuchen',
    Filter: 'Filter',
    'Filter results': 'Resultate filtern',
    'Filter posts': 'Posts filtern',
    'Setup your filter': 'Filter erstellen',
    'Filter by dates': 'Nach Datum filtern',
    'Select what to display': 'Auswählen, was angezeigt werden soll',
    'Display All': 'Alle anzeigen',
    From: 'Von',
    To: 'Bis',
    Date: 'Datum',
    Target: 'Zielgruppe',
    By: 'Von',
    Time: 'Zeit',
    'Delete this question?': 'Diese Frage löschen?',
    'Delete this poll?': 'Diese Abstimmung löschen?',
    'Delete this survey?': 'Diese Umfrage löschen?',
    'Delete this post?': 'Diesen Beitrag löschen?',
    'Delete this program?': 'Dieses Programm löschen?',
    'Open link': 'Link öffnen',
    'Action needed': 'Handlungsbedarf',
    'Select emotion that fits your mood': 'Wähle eine Emotion, die zu deiner Stimmung passt',
    "What's the main reason?": 'Was ist der Hauptgrund hierfür?',
    'Pick up to 3': 'Wähle bis zu 3',
    myself: 'Ich',
    family: 'Familie',
    friends: 'Freunde',
    'social media': 'Soziale Medien',
    wellbeing: 'Wellbeing',
    health: 'Gesundheit',
    school: 'Schule',
    achievement: 'Erfolge',
    sleep: 'Schlaf',
    'How do you feel compared to last time you logged in?': 'Wie fühlst du dich im Vergleich zum letzten Mal als du dich eingeloggt hast?',
    'Do you think things are same for any reason in particular?': 'Gibt es einen bestimmten Grund, warum alles wie beim letzten Mal ist?',
    'Type name for your note here': 'Gebe hier einen Namen für deine Notiz an ',
    Chat: 'Chat',
    'Catch-up': 'Catch-up',
    Menu: 'Menü',
    'Wellbeing Tracker': 'Wohlgefühl Tracker',
    Day: 'Tag',
    'Choose your answer': 'Wähle deine Antwort',
    '1st': '1.',
    '2nd': '2.',
    '3rd': '3.',
    History: 'Historie',
    'My Classroom': 'Mein Klassenzimmer',
    'Actions required': 'Maßnahmen erforderlich',
    'Comments for review': 'Kommentare zur Überprüfung',
    'Actions assigned to me': 'Mir zugewiesene Aufgaben',
    'Student chat': 'Schüler/-innen Chat',
    'Select one option': 'Wähle eine Option',
    Finish: 'Beenden',
    Next: 'Nächste',
    Uncomfortable: 'Unwohl',
    'Classroom Trends': 'Klassenzimmer Trends',
    'Filter Emotions': 'Emotionen filtern',
    Comments: 'Kommentare',
    'Filter Classroom': 'Klassenzimmer filtern',
    'No comments': 'Keine Kommentare',
    'Seen by': 'Gesehen von',
    'Assigned to': 'Zugewiesen zu',
    'Send Private message to student': 'Private Nachricht an einen Schüler/ eine Schülerin senden',
    'Write personal message for the student here': 'Schreibe hier eine private Nachricht für einen Schüler/ eine Schülerin',
    'Select teacher': 'Lehrer auswählen',
    'Assign to teacher': 'Lehrkraft zuweisen',
    'Classroom Teacher': 'Klassenlehrer/-in',
    'Head of Year': 'Jahrgangsleiter/-in',
    'Other Teachers': 'Andere Lehrkräfte',
    'Assign to this teacher': 'Dieser Lehrkraft zuweisen',
    'Type here': 'Hier eingeben ',
    'Message has been sent to student!': 'Nachricht wurde an den Schüler/ die Schülerin verschickt',
    'Check for any student comments that may have been overlooked': 'Prüfe, ob du Kommentare von Schüler/-innen übersehen hast',
    'My message': 'Meine Nachricht',
    Unseen: 'Ungelesen',
    'No unseen replies left': 'Keine ungelesenen Antworten',
    'Congratulations!': 'Herzlichen Glückwunsch!',
    'wellbeing tracker': 'Wohlgefühl Tracker',
    'Mark as seen': 'Als gesehen markieren',
    'Comment has been seen!': 'Kommentar wurde gesehen!',
    'You can press yellow button and create a new Wellbeing profile': 'Du kannst den gelben Button wählen, um ein neues Wellbeing Profil zu erstellen',
    'Your list is empty': 'Deine Liste ist leer',
    'You are not in charge of this student so your messages will be forwarded to school admin or counselor':
        'Du bist nicht für diesen Schüler/ diese Schülerin verantwortlich. Deine Nachricht wird zum Schuladministrator weitergeleitet.',
    'Log comment': 'Kommentar protokollieren',
    'Click to copy email': 'Klicken, um E-mail zu kopieren',
    '% of responses on active polls, questions': '% von Antworten auf aktive Umfragen/Fragen',
    'Date of Birth': 'Geburtstag',
    'Create your own': 'Inhalte selbst erstellen',
    'Ready-to-go': 'Ready-to-go',
    'Feed Posts': 'Feed Post',
    'You are not allowed to create content': 'Du bist nicht dazu berechtigt Inhalte zu erstellen',
    'Upcoming Content': 'Zukünftige Events',
    'Pending Content': 'Ausstehender Inhalt',
    'Create a question': 'Frage erstellen',
    'Headline for question': 'Überschrift der Frage',
    'Headline for poll': 'Überschrift  der Abstimmung',
    Headline: 'Überschrift',
    'Supportive Text': 'Unterstützender Text',
    'Select one item from the list': 'Wähle eine Möglichkeit aus der Liste',
    'Pick one or more options': 'Wähle eine oder mehrere Optionen',
    'Select one or more items from the list': 'Wähle eine oder mehrere Optionen aus der Liste',
    'Enter Link (optional)': 'Link hinzufügen (optional)',
    'Enter any url here': 'Gebe hier eine URL ein',
    AddVideoPhoto: 'Video/Foto hinzufügen',
    'The maximum image size for download is 1400px x 1400px': 'Die maximale Größe für Bilder beträgt 1400px x 1400px',
    'Media file is too big. Try smaller one': 'Mediendatei ist zu groß. Versuche es mit einer kleineren…',
    'Add to Wellbeing Tracker': 'Zum Wellbeing Tracker hinzufügen',
    'Target group is not selected': 'Zielgruppe wurde nicht ausgewählt',
    Option: 'Option',
    'Write option': 'Option schreiben',
    here: 'Hier ',
    'Use Template': 'Vorlage verwenden',
    "You don't have any incoming content": 'Du hast keine externen Beiträge erhalten',
    'Run a journal': 'Tagebuch starten',
    'View Details': 'Details ansehen',
    'Run it': 'Durchlaufen lassen',
    'Run a survey': 'Umfrage starten',
    'Survey needs to be reviewed by the school admin': 'Umfrage muss durch den Schuladministrator geprüft werden',
    'Survey has been created': 'Umfrage wurde erstellt',
    'Select a category': 'Wähle eine Kategorie',
    Favorites: 'Favoriten',
    Customize: 'Anpassen',
    OK: 'OK',
    'Post individual': 'Individueller Beitrag',
    'Select specific teachers you would like to get information from': 'Wähle Lehrkräfte von denen du gerne Informationen erhalten würdest',
    'Select specific year groups to gather more information from': 'Wähle eine Jahrgangsstufe aus, um weitere Informationen zu erhalten',
    'Select specific classes to gather more information from': 'Wähle Klassen aus, um weitere Informationen zu sammeln',
    'Create your own customized group to gather information from': 'Erstelle deine eigene Gruppe, um Informationen zu sammeln',
    'Add to favorites': 'Zu Favoriten hinzufügen',
    feelingMuchWorseQuestion: 'Es tut uns leid zu hören, dass es dir schlechter geht. Welche von den Vorschlägen unten kann dir jetzt weiterhelfen?',
    feelingSameQuestion: 'Was kannst du jetzt tun, um die Lage zu verbessern?',
    feelingBetterQuestion: 'Schön zu hören, dass sich die Lage verbessert hat. Hast du Ideen wie du sie vielleicht noch besser machen könntest? ',
    good: 'gut',
    numb: 'taub',
    Numb: 'Taub',
    worried: 'besorgt',
    read: 'lesen',
    received: 'erhalten',
    experienceIt: '% erleben es',
    anonymousQuestion: 'Anonyme Frage',
    openQuestion: 'Nicht-anonyme Frage',
    Attention: 'Achtung!',
    toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey:
        'Um deine Privatsphäre zu schützen, ist dieser Schlüssel nicht wiederherstellbar. Wenn du diesen Schlüssel vergisst, gehen alle deine Notizen verloren!',
    anonymousPoll: 'Anonyme Abstimmung',
    Previous: 'Vorher',
    'At least 8 characters': 'Mindestens 8 Zeichen',
    'Your results are saved!': 'Deine Ergebnisse wurden gespeichert!',
    rememberMe: 'Angemeldet bleiben',
    instructionVideo: 'Erklärungsvideo',
    instructionVideos: 'Erklärungsvideos',
    yourTasks: 'Deine Aufgaben',
    activitiesForCompletion: 'Ausstehende Aufgaben',
    oopsThereSeemsToBeAnIssueWithConnection: 'Es scheint ein Problem mit deiner Internetverbindung zu geben',
    pleaseTryAgainInAFewMinutestOrContactUpstriveSupport: 'Bitte versuche es erneut in ein paar Minuten oder kontaktiere Upstrive Support',
    loadingMoreFeeds: 'Mehr Inhalte werden geladen',
    openJournal: 'Vertrauliches Tagebuch',
    home: 'Home',
    selectEmotionThatBestDescribesYourMoodToday: 'Wähle eine Emotion, die deine heutige Stimmung am besten beschreibt',
    yourBrowserDoesNotSupportHTMLVideo: 'Dein Browser unterstützt kein HTML-Video',
    whatIsTheMainReason: 'Was ist der Hauptgrund hierfür?',
    pickUpTo3: 'Wähle bis zu 3',
    typeAnyAdditionalTextHere: 'Zusätzlichen Text hier eingeben',
    howDoYouFeelComparedToLastTimeYouLoggedIn: 'Wie fühlst du dich im Vergleich zu dem Zeitpunkt, an dem du dich das letzte Mal eingeloggt hast?',
    iDontWantToThinkAboutItNow: 'Ich möchte gerade nicht darüber nachdenken',
    stepBack: 'Zurückgehen',
    writeYourPersonalNotesHere: 'Schreibe hier deine persönlichen Notizen (nur du kannst diese sehen)',
    whatCouldYouDoToImproveThingsRightNow: 'Was könntest du gerade tun, um die Dinge zu verbessern?',
    selectOneOption: 'Wähle eine Option',
    youHaveMissedThisQuestion: 'Du hast die Frage ausgelassen',
    finish: 'Beenden',
    nextSection: 'Nächster Teil',
    yourAnswersAreSaved: 'Deine Antworten wurden gespeichert!',
    typeYourAnswerHere: 'Gebe deine Antwort hier ein',
    iHaveAnIssueRelatedTo: 'Ich habe ein Problem zum Thema...',
    sorryYourSchoolRestrictedAccessToThisModule: 'Leider hat deine Schule den Zugang zu diesem Modul eingeschränkt.',
    exploreThingsYouCanDoRightNow: 'Was du tun kannst - schnell und einfach',
    seeHowOtherStudentsHandleThis: 'Schaue dir an, wie andere Schüler/-innen damit umgehen ',
    connectWithTheConselor: 'Kontakt zur Beratungslehrkraft herstellen',
    quickTips: 'Schnelle Tipps',
    howToDealWithThisProblem: 'Wie du mit dem Problem umgehen kannst',
    thingsYouCanDoRightNow: 'Dinge, die du gerade tun kannst',
    yesThanks: 'Ja, danke!',
    notReally: 'Nicht wirklich',
    expertRecommendation: 'Experten Empfehlung',
    wasThisSolutionHelpful: 'War die Lösung hilfreich?',
    send: 'Senden',
    topic: 'Thema',
    'I Care / I Listen': 'Ich höre zu',
    privateNotes: 'Private Notizen',
    yourSecretKeyIsSaved: 'Dein Passwort wurde gespeichert!',
    changeSecurityKey: 'Geheimen Schlüssel ändern',
    passwordSetup: 'Passwort wählen',
    atLeast8Caracters: 'Mindestens 8 Zeichen',
    mobileAndDesktopStudentVersion: 'Mobile und Desktop - Schüler/-innen Version.mp4',
    weHopeYouHaveAGoodDay: 'Wir wünschen dir einen schönen Tag!',
    whatAre3ThingsThatAreABitChallengingAtTheMoment: 'Welche drei Dinge sind momentan etwas herausfordernd?',
    whatsJustOneThingYouWillDoDifferentlyTomorrow: 'Nenne eine Sache, die du morgen anders machen wirst ',
    typeOneThingHere: 'Nenne eine Sache',
    'Type 1st thing here': 'Schreibe die erste Sache hier',
    'Type 2nd thing here': 'Schreibe die zweite Sache hier',
    'Type 3rd thing here': 'Schreibe die dritte Sache hier',
    noteHasBeenDeleted: 'Die Notiz wurde gelöscht.',
    returnBack: 'Kehre zurück',
    yourResultsAreSaved: 'Deine Ergebnisse wurden gespeichert!',
    majorUpdate: 'Wichtige Aktualisierung',
    whatsNew: 'Was gibt es Neues?',
    sameGreatAppFreshNewLook: 'Die gleiche tolle App mit neuem Aussehen und neuen Funktionen!',
    next: 'Nächste',
    closePopup: 'Pop-up schließen',
    completed: 'abgeschlossen',
    'No item found': 'Kein Artikel gefunden',
    'Your message is sent! Someone will contact you soon': 'Nachricht geschickt, wir kontaktieren so schnell es geht',
    sec: 'Sekunden',
    'Finish later': 'Später beenden',
    'This day is locked!': 'Dieser Tag ist abgeschlossen!',
    'You have been logged out automatically after 15 minutes': 'Sie wurden automatisch nach 15 Minuten abgemeldet.',
    point: 'Punkt ',
    points: 'Punkte',
    'You are doing great! You earned 5 points for completing survey': 'Tolle Arbeit! Du hast {{value}} Punkte für die Teilnahme an der Umfrage verdient.',
    'Next Video': 'Nächstes Video',
    'Video topic': 'Videotitel',
    Achievements: 'Erfolge  ',
    'Your emotion is confirmed': 'Deine Emotion ist bestätigt.',
    Success: 'Erfolg',
    'Your opinion matters to us!': 'Deine Meinung ist uns wichtig!',
    'Your feedback helps us to improve. If you find our app helpful, please consider rating it.':
        'Dein Feedback hilft uns Upstrive noch besser zu machen und wir würden uns uber ein Rating freuen!',
    'Share your feedback': 'Dein Feedback teilen',
    'Leave your feedback': 'Feedback eingeben',
    'Tell us how we can improve Upstrive in the box below': 'Wie können wir Upstriuve noch besser machen? ',
    'Type your feedback here': 'Hier Feedback eingeben',

    'Dumo Points': 'Dumo Points',
    'Browse achievements': 'Browse Erfolge',
    'Achievements center': 'Ergebnis Center',
    'Earn points by completing tasks and exchange them into rewards': 'Verdiene Punkte, indem du Aufgaben abschließt, und tausche sie gegen Belohnungen ein',
    '10 more points possible to earn today': 'Du hast heute noch die Möglichkeit, 10 weitere Punkte zu verdienen',
    'Check points system': 'Check deine Punkte',
    'Available points': 'Verfügbare Punkte',
    'Our Achievements': 'Unsere Erfolge',
    'Boost your points by earning achivements': 'Steigere deine Punkte, indem du Erfolge erzielst',
    'Daily Achievements': 'Tägliche Erfolge',
    'Features achievements': 'Feature Ergebnisse',
    'Our Rewards': 'Unsere Belohnungen',
    'Exchange your points into rewards': 'Tausche deine Punkte gegen Belohnungen ein.',
    'Transfer earned points to Dummo': 'Übertrage verdiente Punkte auf Dummo',
    'Exchange for a reward': 'Gegen eine Belohnung eintauschen',
    'Task Description': 'Aufgabenbeschreibung',
    'Progress bar': 'Fortschritt',
    'Select as goal': 'Ziel auswählen',
    'Send earned points to DUMO': 'Ziel auswählen',
    'Type your DUMO account here': 'Gib hier dein DUMO-Account ein',
    'Amount of points you want to transfer': 'Punkte, die du übertragen möchtest',
    'Enter your DUMO account': 'Gib dein DUMO Account an',
    Proceed: 'Weiter',
    'Points Earned': 'Verdiente Punkte',
    'This popup will be auto closed in': 'Dieses Popup wird automatisch geschlossen in',
    'Anonymous chats': 'Anonyme Chats',
    'Visible chats': 'Sichtbare Chats',
    'This message will be sent anonymously to your teacher, ensuring your privacy': 'Diese Nachricht wird anonym an Deinen Lehrer gesendet, um Deine Privatsphäre zu schützen',
    'Your opinion matters to us!': 'Deine Meinung ist uns wichtig!',
    'Your feedback helps us to improve. If you find our app helpful, please consider rating it.':
        'Dein Feedback trägt zur Verbesserung bei. Wenn du unsere App hilfreich findest, bitte bewerte sie.',
    'Thank you!': 'Vielen Dank! ',
    'Share your feedback': 'Teil uns deine Meinung mit. ',
    'Leave your feedback': 'Teil uns deine Meinung mit. ',
    'Tell us how we can improve Upstrive in the box below': 'Teile uns im unten stehenden Feld mit, wie wir Upstrive verbessern können',
    'Type your feedback here': 'Teile dein Feedback hier.',
    'Your emotion is confirmed': 'Deine Emotion ist bestätigt.',
    'Day review': 'Mein Tag',

    'Connect with Dummo account': 'Logge dich bei deinem DUMO Konto ein',
    'No item found': 'Kein Artikel gefunden',
    'Enter your DUMO username': 'Gebe deinen DUMO Benutzernamen ein',
    'Write your Dummo username below': 'Schreibe deinen DUMO Benutzername hier unten',
    'Hi, connect your Dummo account': 'Hallo, logge dich in dein DUMO Konto ein ',
    Confirm: 'Bestätigung',
    'No, cancel': 'Nein, abbrechen',
    'Yes, unlink': 'Ja, entfernen',
    'Transfer points': 'Punkte übertragen',

    'Dummo points successfully transfered': 'Dummo-Punkte erfolgreich übertragen',
    'Dummo account successfully connected': 'Dummo-Konto erfolgreich verbunden',

    'Email does not exist': 'Email existiert nicht',
    'Your email address is not valid. Please ask your school admin for new password':
        'Deine E-Mail-Adresse ist ungültig. Bitte frage deinen Administrator nach einem neuen Passwort.',
    'Invalid token, Contact Support': 'Ungültiger Token, bitte kontaktiere Support',
    'Please enter username and password': 'Bitte Usernamen und Passwort eingeben',
    "We can't find an account with this email...": 'Wir finden kein Konto mit dieser Email',
    'Enter credentials you received from school': 'Gib deine Schul- Anmeldedaten ein',
    'This is only for students...': 'Das ist nur für Schüler',
    'Incorrect password.': 'Falsches Passwort',
    'Thank you for helping us to make Upstrive better.': 'Danke, dass du uns hilfst Upstrive besser zu machen',
    'Student Desktop Tutorial': 'Student Desktop Tutorial',
    'Learn how to get the best out of the desktop version of Upstrive by exploring all the features and functionalities this version has to offer.':
        'Lerne, wie du das Beste aus der Desktop-Version von Upstrive herausholen kannst, indem du alle Funktionen und Möglichkeiten dieser Version erkundest.',
    'Student Mobile App Tutorial': 'Schüler:innen Mobile-App Tutorial',
    'Discover all the features, tips and tools to get the best out of your mobile application.':
        'Entdecke alle Funktionen, Tipps und Werkzeuge, und hol das Beste raus aus deiner Mobile-App. ',
    'Delete your private note?': 'Willst du diese private Notiz wirklich löschen?',
    'Invalid token': 'Ungültiger Token',
    Myself: 'Ich',
    Family: 'Familie',
    Friends: 'Freunde',
    'Social media': 'Soziale Medien',
    Wellbeing: 'Wellbeing',
    Health: 'Gesundheit',
    School: 'Schule',
    Achievement: 'Erfolge',
    Sleep: 'Schlaf',
    Confidential: 'Vertrauliches Tagebuch',
    Received: 'Erhalten',
    "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!": 'Bitte Datenschutzbestimmungen zustimmen',
    Continue: 'Weiter',
    'Start Journalling!': 'Tagebuch starten!',
    visitOurWebsiteForMoreDetails: 'Besuche unsere <white>Website</white> für mehr Details',
    'Your journal is for you only — nobody can see what you write, but your teacher can see that you’re working on it':
        'Dein Tagebuch ist nur für dich – niemand kann sehen, was du schreibst. Deine Lehrkraft kann nur sehen, dass du daran arbeitest.',
    'Write full answer here': 'Schreibe die vollständige Antwort hier',
    'You have missed this question': 'Du hast diese Frage verpasst',
    'Next section': 'Nächster Abschnitt',
    'Boost your points by earning achievements': 'Sammle Punkte und schalte neue Erfolge frei',

    //Translate text
    "I think I'm feeling this way because": "I think I'm feeling this way because ...",

    'ordinal.first': 'erste',
    'ordinal.second': 'zweite',
    'ordinal.third': 'dritte',
    'ordinal.fourth': 'vierte',
    'ordinal.fifth': 'fünfte',
    'ordinal.sixth': 'sechste',
    'ordinal.seventh': 'siebte',
    'ordinal.eighth': 'achte',
    'ordinal.ninth': 'neunte',
    'ordinal.tenth': 'zehnte',
    'Type your {{num}} thing here': 'Schreibe deine {{num}} Sache hier',
    "Today's Reflection": 'Heutige Reflexion',
    'What are three good things that happened today?': 'Was sind drei gute Dinge, die heute passiert sind?',
    "Name Today's Notes": 'Nenne die Notizen von heute',
    "Enter a name for today's notes": 'Gib einen Namen für die Notizen von heute ein',
    'Skip for now': 'Für jetzt überspringen',
    'Go Back': 'Zurück',
    'Your Reflection Space': 'Dein Reflexionsraum',
    the: 'die',
    'Add your personal notes here - only you can see them': 'Füge hier deine persönlichen Notizen hinzu - nur du kannst sie sehen',
    'Stay Secure': 'Sicher bleiben',
    'Enter your secret key': 'Gib deinen geheimen Schlüssel ein',
    'We hope you had a good day!': 'Wir hoffen, dass du einen guten Tag hattest!',
    'What are three things that are a bit challenging at the moment?': 'Was sind drei Dinge, die im Moment ein wenig herausfordernd sind?',
    'Share your thoughts here': 'Teile deine Gedanken hier',
    'Create a new password': 'Erstelle ein neues Passwort',
    'Your password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special symbol.':
        'Dein Passwort muss mindestens 8 Zeichen lang sein und einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.',
    'Enter your new password': 'Gib dein neues Passwort ein',
    'Re-enter your new password': 'Gib dein neues Passwort erneut ein',
    'Select your answer': 'Wähle deine Antwort',
    'Confirm new password': 'Neues Passwort bestätigen',
    'Add a short title for your message': 'Fügen Sie einen kurzen Titel für Ihre Nachricht hinzu',
    'Type your message here': 'Geben Sie Ihre Nachricht hier ein',
    'At least 8 characters (upper, lower, number & symbol)': 'Mindestens 8 Zeichen (Groß-, Kleinbuchstaben, Zahl & Symbol)',

    'What’s just one thing you will do differently tomorrow?': 'What’s just one thing you will do differently tomorrow?',
}
export default TRANSLATION_DE
